export default __webpack_public_path__ + "static/media/agrizy-brochure.4a70b789.pdf";